export default __webpack_public_path__ + "static/media/organizacja-wybranych-elementow.62e8268b.md";